/**
 * Sims
 * http://simsrecycling.com
 *
 * Copyright (c) 2017 10up
 * Licensed under the GPL-2.0+ license.
 */

( function( window, $ ) {
	'use strict';

	var $window = $( window ),
		locationMapFinders = [],
		locationMaps = [],
		locationFinderComponents = [];

	/**
	 * Object to represent a location map finder.
	 *
	 * @param {object} map The Google Maps map object this marker belongs to.
	 * @param {object} data Data for the this marker.
	 *
	 * @returns {void}
	 */
	var MapMarker = function( map, data ) {
		this.map = null;
		this.marker = null;
		this.infoWindow = null;
		this.id = 0;
		this.title = '';
		this.latitude = '';
		this.longitude = '';
		this.address = '';
		this.url = '';
		this.icon = {};
		this.showDirectionsLink = false;
		this.settings = {};

		this.initSettings();
		this.init( map, data );
	};

	MapMarker.prototype = {
		init: function( map, data ) {
			if (
				!map ||
				!data ||
				'undefined' === typeof google ||
				'undefined' === typeof google.maps
			) {
				return;
			}

			this.map = map;

			if ( data.id ) {
				this.id = data.id;
			}

			if ( data.title ) {
				this.title = data.title;
			}

			if ( data.latitude ) {
				this.latitude = data.latitude;
			}

			if ( data.longitude ) {
				this.longitude = data.longitude;
			}

			if ( data.address ) {
				this.address = data.address;
			}

			if ( data.url ) {
				this.url = data.url;
			}

			if ( data.icon ) {
				this.icon = data.icon;
			}

			if ( data.infoWindow ) {
				this.infoWindow = data.infoWindow;
			}

			if ( data.showDirectionsLink ) {
				this.showDirectionsLink = data.showDirectionsLink;
			}

			var markerOpts = {
				position: this.getMarkerPoint(),
				icon: this.icon
			};

			if ( true !== data.isClustering ) {
				markerOpts.map = this.map;
			}

			this.marker = new google.maps.Marker( markerOpts );

			this.initEvents();
		},

		/**
		 * Initialize the settings.
		 *
		 * @returns {void}
		 */
		initSettings: function() {
			if ( 'undefined' === typeof locationFinderAPISettings ) {
				return;
			}

			if ( locationFinderAPISettings ) {
				this.settings = locationFinderAPISettings;
			}
		},

		getSetting: function( setting ) {
			if ( this.settings && this.settings.hasOwnProperty( setting ) ) {
				return this.settings[setting];
			} else {
				return null;
			}
		},

		initEvents: function() {
			if ( !this.infoWindow ) {
				return;
			}

			this.marker.addListener( 'click', $.proxy( this.showInfoWindow, this ) );
		},

		getMap: function() {
			return this.map;
		},

		getMarker: function() {
			return this.marker;
		},

		getMarkerPoint: function() {
			var point = new google.maps.LatLng(
				parseFloat( this.latitude ),
				parseFloat( this.longitude )
			);

			return point;
		},

		showInfoWindow: function() {
			var infoWindow = this.getInfoWindow(),
				infoWindowContent = this.getInfoWindowContent();

			if (
				!infoWindow ||
				!infoWindowContent ||
				!this.map ||
				!this.marker
			) {
				return;
			}

			infoWindow.setContent( infoWindowContent );
			infoWindow.open( this.map, this.marker );
		},

		getInfoWindow: function() {
			return this.infoWindow;
		},

		getInfoWindowContent: function() {
			var content = document.createElement( 'div' ),
				title = document.createElement( 'strong' ),
				address = document.createElement( 'span' ),
				url = document.createElement( 'a' ),
				paragraph = document.createElement( 'p' );

			if ( this.title ) {
				title.innerHTML = this.title;
				paragraph.appendChild( title );
				paragraph.appendChild( document.createElement( 'br' ) );
			}

			if ( this.address ) {
				address.innerHTML = this.address;
				paragraph.appendChild( address );
				paragraph.appendChild( document.createElement( 'br' ) );
			}

			content.appendChild( paragraph );

			if ( this.url ) {
				paragraph = document.createElement( 'p' );

				url.textContent = 'Location Details';
				url.setAttribute( 'href', this.url );
				paragraph.appendChild( url );

				content.appendChild( paragraph );
			}

			if ( true === this.showDirectionsLink ) {
				var directionsUrl = document.createElement( 'a' );

				paragraph = document.createElement( 'p' );

				directionsUrl.textContent = 'Get Directions';
				if (
					this.settings.hasOwnProperty( 'origin' ) &&
					'object' === typeof this.settings.origin &&
					this.settings.origin.hasOwnProperty( 'formatted_address' ) &&
					'undefined' !== typeof this.settings.origin.formatted_address
				) {
					directionsUrl.setAttribute( 'href', 'https://www.google.com/maps?saddr=' + this.settings.origin.formatted_address + '&daddr=+' + this.latitude + ',+' + this.longitude );
				} else {
					directionsUrl.setAttribute( 'href', 'https://www.google.com/maps?daddr=+' + this.latitude + ',+' + this.longitude );
				}
				directionsUrl.setAttribute( 'target', '_blank' );
				directionsUrl.setAttribute( 'rel', 'noopener noreferrer' ); // https://www.jitbit.com/alexblog/256-targetblank---the-most-underestimated-vulnerability-ever/
				paragraph.appendChild( directionsUrl );

				content.appendChild( paragraph );
			}

			return content;
		}
	};

	/**
	 * Object to represent a location map finder.
	 *
	 * @param {object} el The container element for the location finder.
	 *
	 * @returns {void}
	 */
	var LocationMapFinder = function( el ) {
		this.$el = null;
		this.$mapEl = null;
		this.$searchFieldEl = null;
		this.map = null;
		this.infoWindow = null;
		this.locations = [];
		this.markers = [];
		this.currentLocationMarker = null;
		this.settings = {};

		this.init( el );
	};

	LocationMapFinder.prototype = {
		/**
		 * Initialize the object.
		 *
		 * @param {object} el The container element for the object.
		 *
		 * @returns {void}
		 */
		init: function( el ) {
			if (
				!el ||
				'undefined' === typeof google ||
				'undefined' === typeof google.maps
			) {
				return;
			}

			this.$el = $( el );
			this.$mapEl = this.$el.find( '.map' );
			this.$searchFieldEl = this.$el.find( '.search-field' );

			this.initSettings();
			this.initMap();
		},

		/**
		 * Initialize the settings.
		 *
		 * @returns {void}
		 */
		initSettings: function() {
			if ( 'undefined' === typeof locationFinderAPISettings ) {
				return;
			}

			if ( locationFinderAPISettings ) {
				this.settings = locationFinderAPISettings;
			}
		},

		getSetting: function( setting ) {
			if ( this.settings && this.settings.hasOwnProperty( setting ) ) {
				return this.settings[setting];
			} else {
				return null;
			}
		},

		/**
		 * Display an error message on the front-end below the form input field
		 *
		 * @param {string} errorMessage Error message text
		 *
		 * @returns {void}
		 */
		errorNotice: function( errorMessage ) {
			var $formEl = document.getElementById( 'location-map-form' ),
				errorEl = document.createElement( 'div' );

			if ( errorMessage.length ) {
				errorEl.className += 'location-map-error';
				errorEl.innerHTML = errorMessage;

				$formEl.appendChild( errorEl );
			}
		},

		/**
		 * Convert number to radians
		 *
		 * @param {number} v Number to convert
		 *
		 * @returns {number} Number converted to radians
		 */
		geoCodeCalcToRadian: function( v ) {
			return v * ( Math.PI / 180 );
		},

		/**
		 * Calculate radian difference
		 *
		 * @param {number} v1 Latitude
		 * @param {number} v2 Longitude
		 *
		 * @returns {number} Difference in radians
		 */
		geoCodeCalcDiffRadian: function( v1, v2 ) {
			return this.geoCodeCalcToRadian( v2 ) - this.geoCodeCalcToRadian( v1 );
		},

		/**
		 * Distance calculation using haversine formula
		 *
		 * @param {number} lat1 First latitude
		 * @param {number} lng1 First longitude
		 * @param {number} lat2 Second latitude
		 * @param {number} lng2 Second longitude
		 *
		 * @returns {number} Distance calculation in miles.
		 */
		geoCodeCalcCalcDistance: function( lat1, lng1, lat2, lng2 ) {
			// Earth radius value for calculating miles.
			var radius = 3956;

			/* eslint-disable */
			return radius * 2 * Math.asin( Math.min( 1, Math.sqrt( ( Math.pow( Math.sin( ( this.geoCodeCalcDiffRadian( lat1, lat2 ) ) / 2.0 ), 2.0 ) + Math.cos( this.geoCodeCalcToRadian( lat1 ) ) * Math.cos( this.geoCodeCalcToRadian( lat2 ) ) * Math.pow( Math.sin( ( this.geoCodeCalcDiffRadian( lng1, lng2 ) ) / 2.0 ), 2.0 ) ) ) ) );
			/* eslint-enable */
		},

		/**
		 * Check for query string parameter
		 *
		 * @param {string} param Query string parameter to check for
		 *
		 * @returns {string} query string value
		 */
		getQueryString: function( param ) {
			if ( param ) {
				param = param.replace( /[\[]/, '\\[' ).replace( /[\]]/, '\\]' );
				var regex = new RegExp( '[\\?&]' + param + '=([^&#]*)' ),
					results = regex.exec( location.search );

				return results === null ? '' : decodeURIComponent( results[1].replace( /\+/g, ' ' ) );
			}
		},

		/**
		 * Initialize events for the finder.
		 *
		 * @returns {void}
		 */
		initMap: function() {
			var $map = this.getMapEl();

			if ( !$map.length ) {
				return;
			}

			var map = $map[0],
				startingLatitude = 35.02999636902566, // Default is the middle of the North Atlantic Ocean.
				startingLongitude = 21, // Default is the middle of the North Atlantic Ocean.
				$parentEl = this.getEl(),
				zoom = Math.ceil( Math.log( $parentEl.width() ) / Math.log( 2 ) ) - 9, // Use a formula to try and show the entire world in view by default.
				startingPoint = this.getSetting( 'startingPoint' ),
				startingPlace = this.getSetting( 'startingPlace' );

			// zoom in one and reposition for mobile
			if ( $parentEl.width() < 768 ) {
				zoom += 1;
				startingLongitude -= 60;
			}

			if ( 'US' === this.getSetting( 'siteCountry' ) ) {
				startingLatitude = 51.3647227;
				startingLongitude = -102.754154;
				zoom = 3;
			}
			if ( 'UK' === this.getSetting( 'siteCountry' ) ) {
				startingLatitude = 53.97223360827683;
				startingLongitude = -1.751253606585692;
				zoom = 6;
			}

			if ( 'AU' === this.getSetting( 'siteCountry' ) ) {
				startingLatitude = -25.286830176809314;
				startingLongitude = 135.64218615000004;
				zoom = 4;
			}

			this.map = new google.maps.Map( map );

			// Remove unneeded map options like points-of-interest.
			this.map.setOptions( {styles: [
				{
					featureType: 'poi',
					stylers: [{visibility: 'off'}]
				},
				{
					featureType: 'transit',
					stylers: [{visibility: 'off'}]
				}
			]} );

			if ( startingPlace ) {
				this.setMapToPlaceID( startingPlace );
			} else if ( startingPoint && startingPoint.latitude && startingPoint.longitude ) {
				startingLatitude = parseFloat( startingPoint.latitude );
				startingLongitude = parseFloat( startingPoint.longitude );
				zoom = 10;

				this.setMapToPoint( startingLatitude, startingLongitude, zoom );
			} else {
				this.setMapToPoint( startingLatitude, startingLongitude, zoom );

				// Initialize geolocation only if a starting place or point was not specified.
				this.initGeolocation();
			}

			this.initInfoWindow();
			this.getLocations();
			this.initSearchField();
		},

		/**
		 * Set the map to a place ID returned from the Places API
		 *
		 * @param {string|integer} placeID The place ID.
		 * @param {boolean} adjustViewForNearestMarker Determine whether to adjust the map bounds so the nearest location is in view.
		 *
		 * @returns {void}
		 */
		setMapToPlaceID: function( placeID, adjustViewForNearestMarker ) {
			var self = this;

			if ( !placeID ) {
				return;
			}

			var map = this.getMap();

			if ( !map ) {
				return;
			}

			var service = new google.maps.places.PlacesService( map );

			service.getDetails( {
				placeId: placeID
			}, function( place, status ) {
				if ( status === google.maps.places.PlacesServiceStatus.OK ) {
					self.setMapToPlace( place, adjustViewForNearestMarker );
				}
			} );
		},

		/**
		 * Geocode
		 *
		 * @callback requestCallback
		 * @param {object} request Geocode request object.
		 * @param {requestCallback} callbackFunction Geocode callback function
		 *
		 * @returns {void}
		 */
		geocode: function( request, callbackFunction ) {
			var geocoder = new google.maps.Geocoder();

			geocoder.geocode( request, function( results, status ) {
				if ( status === google.maps.GeocoderStatus.OK ) {
					var result = {};

					result.latitude = results[0].geometry.location.lat();
					result.longitude = results[0].geometry.location.lng( );
					result.geocodeResult = results[0];
					callbackFunction( result );
				} else {
					callbackFunction( null );
				}
			} );
		},

		/**
		 * Set the map to a place returned from the Places API.
		 *
		 * @param {object} place The place object.
		 * @param {boolean} adjustViewForNearestMarker Determine whether to adjust the map bounds so the nearest location is in view.
		 *
		 * @returns {void}
		 */
		setMapToPlace: function( place, adjustViewForNearestMarker ) {
			var map = this.getMap();

			if ( !place || !place.geometry || !map ) {
				return;
			}

			if ( true === adjustViewForNearestMarker ) {
				this.setCurrentLocationMarker( map, place.geometry.location.lat(), place.geometry.location.lng() );
				this.setMapToPoint( place.geometry.location.lat(), place.geometry.location.lng(), 0, true );
			} else {
				this.setCurrentLocationMarker( map, place.geometry.location.lat(), place.geometry.location.lng() );

				// Set the map center to the place's location
				map.setCenter( place.geometry.location );

				var newBounds = new google.maps.LatLngBounds();

				// Set the map bounds to the recommended bounds for the place.
				newBounds.extend( place.geometry.viewport.getNorthEast() );
				newBounds.extend( place.geometry.viewport.getSouthWest() );

				map.fitBounds( newBounds );
			}
		},

		/**
		 * Set the map to a point by latitude and longitude. Optionally adjust the map bounds to show the nearest map marker.
		 *
		 * @param {integer} latitude The latitude for the point.
		 * @param {integer} longitude The longitude for the point.
		 * @param {integer} zoom The zoom level for the map.
		 * @param {boolean} adjustViewForNearestMarker Determine whether to adjust the map bounds so the nearest location is in view.
		 *
		 * @returns {void}
		 */
		setMapToPoint: function( latitude, longitude, zoom, adjustViewForNearestMarker ) {
			if ( !latitude || !longitude ) {
				return;
			}

			var map = this.getMap();

			if ( !map ) {
				return;
			}

			if ( true === adjustViewForNearestMarker ) {
				// Update the locations array to include the distance from the origin to each location.
				this.updateLocationDistance( latitude, longitude );

				// Sort the locations by distance.
				this.locations.sort( this.sortLocationsByDistance );

				var distance = 0,
					nearestLocation = null,
					mapBounds = new google.maps.LatLngBounds(),
					origin = new google.maps.LatLng( latitude, longitude );

				mapBounds.extend( origin );

				// Get the nearest marker by looking for the first location a set distance away from the origin. This will produce better results when multiple locations areclustered around a specific point.
				for ( var i = 0; i < this.locations.length; i++ ) {
					distance = this.locations[i].distance;

					// Target locations 20 miles away from the search origin.
					if ( parseInt( distance ) <= 15 ) {
						nearestLocation = this.locations[i];

						// Extend the map bounds to include this location on view.
						mapBounds.extend( new google.maps.LatLng( nearestLocation.lat, nearestLocation.lng ) );
					} else {
						break;
					}
				}

				// If we didn't find a nearby location, set it to the closest location.
				if ( !nearestLocation || !nearestLocation.id ) {
					nearestLocation = this.locations[0];

					// Extend the map bounds to include this location on view.
					mapBounds.extend( new google.maps.LatLng( nearestLocation.lat, nearestLocation.lng ) );
				}

				map.fitBounds( mapBounds );
			} else {
				map.setCenter( new google.maps.LatLng( latitude, longitude ) );
				map.setZoom( zoom );
			}
		},

		initInfoWindow: function() {
			this.infoWindow = new google.maps.InfoWindow();
		},

		initGeolocation: function() {
			if ( true !== this.supportsGeolocation() ) {
				return;
			}

			var self = this;

			// Try HTML5 geolocation.
			if ( navigator.geolocation ) {
				navigator.geolocation.getCurrentPosition( function( position ) {
					var pos = {
						lat: position.coords.latitude,
						lng: position.coords.longitude
					};

					var infoWindow = new google.maps.InfoWindow();

					self.map.setCenter( pos );
					self.map.setZoom( 10 );

					infoWindow.setPosition( pos );
					infoWindow.setContent( 'Your location was found.' );
					infoWindow.open( self.map );
				}, function() {
					// Handle location detection problems here if needed.
				} );
			}
		},

		/**
		 * Initialize functionality when query string parameter value is set from the shortcode component.
		 *
		 * @returns {void}
		 */
		initQueryStringVal: function() {
			var map = this.getMap(),
				$searchFieldEl = this.getSearchFieldEl(),
				self = this,
				placeQueryString = this.getQueryString( 'place' ),
				locationQueryString = this.getQueryString( 'location' ),
				geocodeBounds = self.getSetting( 'geocodeBounds' ),
				geocodeRestrictions = self.getSetting( 'geocodeRestrictions' );

			if ( !locationQueryString && !placeQueryString ) {
				return;
			}

			if ( placeQueryString ) {
				self.setMapToPlaceID( placeQueryString, true );
				return;
			}

			if ( $searchFieldEl.length ) {
				// Fill in the input field with the query string value.
				$searchFieldEl[0].value = locationQueryString;
			}

			// Geocode the input.
			self.geocode( {
				address: locationQueryString,
				bounds: geocodeBounds,
				componentRestrictions: geocodeRestrictions
			}, function( data ) {
				if ( data && data.hasOwnProperty( 'latitude' ) && data.hasOwnProperty( 'longitude' ) ) {
					self.setMapToPoint( data.latitude, data.longitude, 0, true );
					self.setCurrentLocationMarker( map, data.latitude, data.longitude );
				} else {
					self.errorNotice( 'We were unable to find a location near your search area.' );
				}
			} );
		},

		initSearchField: function() {
			var map = this.getMap(),
				$searchFieldEl = this.getSearchFieldEl();

			if (
				!map ||
				'undefined' === typeof google ||
				'undefined' === typeof google.maps ||
				'undefined' === typeof google.maps.places ||
				'undefined' === typeof google.maps.places.Autocomplete
			) {
				return;
			}

			if ( !$searchFieldEl.length ) {
				return;
			}

			var siteUrl = window.location.hostname,
				field = $searchFieldEl[0],
				self = this,
				types = ['geocode'], // This will ignore businesses in the autocomplete results.
				bounds = new google.maps.LatLngBounds(
					new google.maps.LatLng( -90, -180 ),
					new google.maps.LatLng( 90, 180 )
				);

			if ( siteUrl.includes( 'simsmm.com' ) ) {
				if ( 'US' === this.getSetting( 'siteCountry' ) ) {
					bounds = new google.maps.LatLngBounds(
						new google.maps.LatLng( 19.258993570986306, -167.8371618125 ),
						new google.maps.LatLng( 70.24078219974115, -37.671146187500014 )
					);
				} else {
					bounds = new google.maps.LatLngBounds(
						new google.maps.LatLng( -62.0891579262991, 112.58589632499998 ),
						new google.maps.LatLng( 3.5448253023662666, -124.54300992500004 )
					);
				}
			}

			if ( siteUrl.includes( 'simsmm.com.au' ) ) {
				bounds = new google.maps.LatLngBounds(
					new google.maps.LatLng( -62.0891579262991, 112.58589632499998 ),
					new google.maps.LatLng( 3.5448253023662666, -124.54300992500004 )
				);
			}

			var autocomplete = new google.maps.places.Autocomplete( field, {
					bounds: bounds,
					types: types
				} ),
				$locationForm = document.getElementById( 'location-map-form' ),
				$errorNotices = document.getElementsByClassName( 'location-map-error' ),
				geocodeBounds = self.getSetting( 'geocodeBounds' ),
				geocodeRestrictions = self.getSetting( 'geocodeRestrictions' );

			autocomplete.addListener( 'place_changed', function() {
				var place = autocomplete.getPlace(),
					$errorNotices = document.getElementsByClassName( 'location-map-error' ),
					trackingCountry = self.getSetting( 'siteCountry' );

				// Remove any previous error notices.
				if ( $errorNotices.length ) {
					while ( $errorNotices.length > 0 ) {
						$errorNotices[0].parentNode.removeChild( $errorNotices[0] );
					}
				}

				if ( trackingCountry && place.formatted_address && typeof gtag !== 'undefined' ) {
					gtag( 'event', trackingCountry, {
						'event_category': 'Location Suggestion',
						'event_label': place.formatted_address
					} );
				}

				self.settings.origin = place;
				self.setMapToPlace( place, true );
			} );

			// Add event handler for geocoding when the user presses enter in the search field instead of selecting a suggestion
			$locationForm.onsubmit = function( e ) {
				e.preventDefault();

				var trackingCountry = self.getSetting( 'siteCountry' );

				// Remove any previous error notices.
				if ( $errorNotices.length ) {
					while ( $errorNotices.length > 0 ) {
						$errorNotices[0].parentNode.removeChild( $errorNotices[0] );
					}
				}

				// Check for blank input.
				if ( '' === $searchFieldEl[0].value ) {
					return;
				}

				// Track the entered value.
				if ( typeof gtag !== 'undefined' ) {
					gtag(
						'event', trackingCountry, {
							'event_category': 'Location Search',
							'event_label': $searchFieldEl[0].value
						}
					);
				}

				// Geocode the input.
				self.geocode( {
					address: $searchFieldEl[0].value,
					bounds: geocodeBounds,
					componentRestrictions: geocodeRestrictions
				}, function( data ) {
					if ( data && data.hasOwnProperty( 'latitude' ) && data.hasOwnProperty( 'longitude' ) ) {
						self.setMapToPoint( data.latitude, data.longitude, 0, true );
						self.setCurrentLocationMarker( map, data.latitude, data.longitude );
					} else {
						self.errorNotice( 'We were unable to find a location near your search area.' );
					}
				} );
			};
		},

		supportsGeolocation: function() {
			if ( 1 === parseInt( this.getSetting( 'supportsGeolocation' ) ) ) {
				return true;
			}

			return false;
		},

		/**
		 * Get the container element for finder.
		 *
		 * @returns {object} The element.
		 */
		getEl: function() {
			return this.$el;
		},

		/**
		 * Get the container element for the map.
		 *
		 * @returns {object} The element.
		 */
		getMapEl: function() {
			return this.$mapEl;
		},

		/**
		 * Get the search field element for the map.
		 *
		 * @returns {object} The element.
		 */
		getSearchFieldEl: function() {
			return this.$searchFieldEl;
		},

		/**
		 * Get the map element for the map.
		 *
		 * @returns {object} The map.
		 */
		getMap: function() {
			return this.map;
		},

		/**
		 * Get the info window element for map markers.
		 *
		 * @returns {object} The info window.
		 */
		getInfoWindow: function() {
			return this.infoWindow;
		},

		/**
		 * Get locations via an AJAX request.
		 *
		 * @returns {void}
		 */
		getLocations: function() {
			var url = this.getSetting( 'mapFinderAPIGetLocationsURL' ),
				data = {},
				self = this;

			data._wpnonce = this.getSetting( 'nonce' );

			$.ajax( {
				url: url,
				method: 'GET',
				dataType: 'xml',
				data: data
			} ).success( function( response ) {
				self.handleGetLocationsResponse( response );
			} );
		},

		/**
		 * Handle the response returned when requesting locations.
		 *
		 * @param {string} response The XML response containing map markers.
		 *
		 * @returns {void}
		 */
		handleGetLocationsResponse: function( response ) {
			if ( !response ) {
				return;
			}

			var xml = response;
			var markers = xml.documentElement.getElementsByTagName( 'marker' );

			this.populateMap( markers );
		},

		populateMap: function( markers ) {
			if ( !markers ) {
				return;
			}

			// Parse the XMl so the location data is easier to work with.
			this.parseXML( markers );

			var self = this,
				map = this.getMap(),
				infoWindow = this.getInfoWindow(),
				markerClusterer = null,
				isClustering = false;

			if ( true === this.shouldClusterMarkers() ) {
				isClustering = true;

				markerClusterer = new MarkerClusterer( map, [], {
					styles: [{
						url: this.getSetting( 'mapImagesPath' ) + 'cluster-dark-1.svg',
						height: 29,
						width: 29,
						anchor: [0, 0],
						textColor: '#ffffff',
						textSize: 12
					}] // Up to five markers can be defined and they can vary in size and color. Marker #5 would be used for clusters with the most locations.
				} );
			}

			Array.prototype.forEach.call( markers, function( location ) {
				var mapMarker = new MapMarker( map, {
					'icon': {
						url: self.getSetting( 'mapImagesPath' ) + 'pin.svg',
						size: new google.maps.Size( 19, 27 ),
						scaledSize: new google.maps.Size( 19, 27 ),
						origin: new google.maps.Point( 0, 0 ),
						anchor: new google.maps.Point( 0, 27 )
					},
					'id': location.getAttribute( 'id' ),
					'title': location.getAttribute( 'name' ),
					'address': location.getAttribute( 'address' ),
					'latitude': location.getAttribute( 'lat' ),
					'longitude': location.getAttribute( 'lng' ),
					'url': location.getAttribute( 'url' ),
					'infoWindow': infoWindow,
					'isClustering': isClustering, // Let the marker know if we are clustering markers so we don't render markers multiple times.
					'showDirectionsLink': true
				} );

				// Add marker to array so it can be referenced later.
				self.markers[location.getAttribute( 'id' )] = mapMarker;

				if ( true === self.shouldClusterMarkers() ) {
					markerClusterer.addMarker( mapMarker.marker );
				}
			} );

			this.initQueryStringVal();
		},

		shouldClusterMarkers: function() {
			if ( 'function' === typeof MarkerClusterer ) {
				return true;
			}

			return false;
		},

		/**
		 * Parse the XML location data into an array.
		 *
		 * @param {array} markers Markers array
		 *
		 * @returns {void}
		 */
		parseXML: function( markers ) {
			var locationSet = [];

			Array.prototype.forEach.call( markers, function( el, index, array ) {
				var locationData = {};

				for ( var key in el.attributes ) {

					if ( el.attributes.hasOwnProperty( key ) ) {
						locationData[ el.attributes[ key ].name ] = el.attributes[ key ].value;
					}
				}

				locationSet[ index ] = locationData;
			} );

			this.locations = locationSet;
		},

		/**
		 * Sort the markers by distance.
		 *
		 * @param {object} a First marker to compare.
		 * @param {object} b Second marker to compare.
		 *
		 * @returns {number} Comparison result
		 */
		sortLocationsByDistance: function( a, b ) {
			return a.distance - b.distance;
		},

		/**
		 * Add distances to each of the locations from the origin.
		 *
		 * @param {number} originLat Origin latitude.
		 * @param {number} originLng Origin longitude.
		 *
		 * @returns {void}
		 */
		updateLocationDistance: function( originLat, originLng ) {
			if ( this.locations.length < 1 ) {
				return;
			}

			var distance = null;

			for ( var i = 0; i < this.locations.length; i++ ) {
				distance = this.geoCodeCalcCalcDistance( originLat, originLng, this.locations[ i ].lat, this.locations[ i ].lng );

				this.locations[ i ].distance = distance;
			}
		},

		/**
		 * Create a marker for the current location searched for.
		 *
		 * @param {object} map The map object.
		 * @param {number} latitude The longitude value for the marker.
		 * @param {number} longitude The latitude value for the marker.
		 *
		 * @returns {void}
		 */
		setCurrentLocationMarker: function( map, latitude, longitude ) {
			if ( !map || !longitude || !latitude ) {
				return;
			}

			if ( this.currentLocationMarker && this.currentLocationMarker.marker ) {
				this.currentLocationMarker.marker.setMap( null );
				this.currentLocationMarker = null;
			}

			this.currentLocationMarker = new MapMarker( map, {
				'icon': {
					url: this.getSetting( 'mapImagesPath' ) + 'location.svg',
					size: new google.maps.Size( 48, 48 ),
					scaledSize: new google.maps.Size( 36, 36 ),
					origin: new google.maps.Point( 0, 0 ),
					anchor: new google.maps.Point( 18, 18 )
				},
				'latitude': latitude,
				'longitude': longitude
			} );

		}

	};

	/**
	 * Object to represent a location finder component.
	 *
	 * @param {object} el The container element for the location finder component.
	 *
	 * @returns {void}
	 */
	var LocationFinderComponent = function( el ) {
		this.$el = null;
		this.$searchFieldEl = null;
		this.settings = {};

		this.init( el );
	};

	LocationFinderComponent.prototype = {
		/**
		 * Initialize the object.
		 *
		 * @param {object} el The container element for the object.
		 *
		 * @returns {void}
		 */
		init: function( el ) {
			if (
				!el ||
				'undefined' === typeof google ||
				'undefined' === typeof google.maps
			) {
				return;
			}

			this.$el = $( el );
			this.$searchFieldEl = this.$el.find( '.search-field' );

			this.initSettings();
			this.initSearchField();
		},

		/**
		 * Initialize the settings.
		 *
		 * @returns {void}
		 */
		initSettings: function() {
			if ( 'undefined' === typeof locationFinderAPISettings ) {
				return;
			}

			if ( locationFinderAPISettings ) {
				this.settings = locationFinderAPISettings;
			}
		},

		getSetting: function( setting ) {
			if ( this.settings && this.settings.hasOwnProperty( setting ) ) {
				return this.settings[setting];
			} else {
				return null;
			}
		},

		initSearchField: function() {
			var $searchFieldEl = this.getSearchFieldEl(),
				self = this;

			if (
				'undefined' === typeof google ||
				'undefined' === typeof google.maps
			) {
				if ( $searchFieldEl.length ) {
					$searchFieldEl.hide(); // Hide the search field so we don't show a non-functioning field.
				}

				return;
			}

			if ( !$searchFieldEl.length ) {
				return;
			}

			var field = $searchFieldEl[0],
				types = ['geocode'], // This will ignore businesses in the autocomplete results.
				bounds = new google.maps.LatLngBounds(
					new google.maps.LatLng( -90, -180 ),
					new google.maps.LatLng( 90, 180 )
				);

			if ( siteUrl.includes( 'simsmm.com' ) ) {
				if ( 'US' === this.getSetting( 'siteCountry' ) ) {
					bounds = new google.maps.LatLngBounds(
						new google.maps.LatLng( 19.258993570986306, -167.8371618125 ),
						new google.maps.LatLng( 70.24078219974115, -37.671146187500014 )
					);
				} else {
					bounds = new google.maps.LatLngBounds(
						new google.maps.LatLng( -62.0891579262991, 112.58589632499998 ),
						new google.maps.LatLng( 3.5448253023662666, -124.54300992500004 )
					);
				}
			}

			if ( siteUrl.includes( 'simsmm.com.au' ) ) {
				bounds = new google.maps.LatLngBounds(
					new google.maps.LatLng( -62.0891579262991, 112.58589632499998 ),
					new google.maps.LatLng( 3.5448253023662666, -124.54300992500004 )
				);
			}

			var autocomplete = new google.maps.places.Autocomplete( field, {
					bounds: bounds,
					types: types
				} ),
				$searchForm = document.getElementsByClassName( 'location-finder-component' ),
				mapPageURL = self.getMapPageURL(),
				trackingCountry = self.getSetting( 'siteCountry' );

			if ( !mapPageURL ) {
				return;
			}

			autocomplete.addListener( 'place_changed', function() {
				var place = autocomplete.getPlace(),
					trackingCountry = self.getSetting( 'siteCountry' );

				if ( !place.geometry ) {
					return;
				}

				if ( trackingCountry && place.formatted_address && typeof gtag !== 'undefined' ) {
					gtag( 'event', trackingCountry, {
						'event_category': 'Location Suggestion',
						'event_label': place.formatted_address
					} );
				}

				mapPageURL = self.addURLParam( mapPageURL, 'place', place.place_id );

				window.location.href = mapPageURL;
				return;
			} );

			// Add event handler for geocoding when the user presses enter in the search field instead of selecting a suggestion
			$searchForm[0].onsubmit = function( e ) {
				e.preventDefault();

				// Check for blank input and do nothing if empty.
				if ( '' === field.value ) {
					return;
				}

				// Track the entered value.
				if ( typeof gtag !== 'undefined' ) {
					gtag( 'event', trackingCountry, {
						'event_category': 'Location Search',
						'event_label': field.value
					} );
				}

				mapPageURL = self.addURLParam( mapPageURL, 'location', field.value );
				window.location.href = mapPageURL;
			};
		},

		/**
		 * Get the container element for finder.
		 *
		 * @returns {object} The element.
		 */
		getEl: function() {
			return this.$el;
		},

		/**
		 * Get the search field element for the map.
		 *
		 * @returns {object} The element.
		 */
		getSearchFieldEl: function() {
			return this.$searchFieldEl;
		},

		/**
		 * Get the map page URL to direct users to after the choose a location in the search field.
		 *
		 * @returns {object} The element.
		 */
		getMapPageURL: function() {
			var $searchFieldEl = this.getSearchFieldEl();

			if ( !$searchFieldEl.length ) {
				return;
			}

			var url = $searchFieldEl.attr( 'data-map-page-url' );

			return url;
		},

		addURLParam: function( url, key, value ) {
			if ( !url || !key || !value ) {
				return url;
			}

			var separator = url.indexOf( '?' ) !== -1 ? '&' : '?';

			return url + separator + key + '=' + value;
		}
	};

	/**
	 * Object to represent a location map finder.
	 *
	 * @param {object} el The container element for the location finder.
	 *
	 * @returns {void}
	 */
	var LocationMap = function( el ) {
		this.$el = null;
		this.$mapEl = null;
		this.map = null;
		this.infoWindow = null;
		this.settings = {};

		this.init( el );
	};

	LocationMap.prototype = {
		/**
		 * Initialize the object.
		 *
		 * @param {object} el The container element for the object.
		 *
		 * @returns {void}
		 */
		init: function( el ) {
			if (
				!el ||
				'undefined' === typeof google ||
				'undefined' === typeof google.maps
			) {
				return;
			}

			this.$el = $( el );
			this.$mapEl = this.$el.find( '.map' );

			this.initSettings();
			this.initMap();
		},

		/**
		 * Initialize the settings.
		 *
		 * @returns {void}
		 */
		initSettings: function() {
			if ( 'undefined' === typeof locationMapSettings ) {
				return;
			}

			if ( locationMapSettings ) {
				this.settings = locationMapSettings;
			}
		},

		getSetting: function( setting ) {
			if ( this.settings && this.settings.hasOwnProperty( setting ) ) {
				return this.settings[setting];
			} else {
				return null;
			}
		},

		/**
		 * Initialize events for the finder.
		 *
		 * @returns {void}
		 */
		initMap: function() {
			var $map = this.getMapEl();

			if ( !$map.length ) {
				return;
			}

			var map = $map[0],
				latitude = this.getSetting( 'latitude' ),
				longitude = this.getSetting( 'longitude' ),
				$parentEl = this.getEl(),
				zoom = 15;

			if ( !latitude || !latitude ) {
				return;
			}

			this.map = new google.maps.Map( map );

			this.setMapToPoint( latitude, longitude, zoom );

			this.initInfoWindow();
			this.populateMap();
		},

		setMapToPoint: function( latitude, longitude, zoom ) {
			if ( !latitude || !longitude ) {
				return;
			}

			var map = this.getMap();

			if ( !map ) {
				return;
			}

			map.setCenter( new google.maps.LatLng( latitude, longitude ) );
			map.setZoom( zoom );
		},

		initInfoWindow: function() {
			this.infoWindow = new google.maps.InfoWindow();
		},

		/**
		 * Get the container element for finder.
		 *
		 * @returns {object} The element.
		 */
		getEl: function() {
			return this.$el;
		},

		/**
		 * Get the container element for the map.
		 *
		 * @returns {object} The element.
		 */
		getMapEl: function() {
			return this.$mapEl;
		},

		/**
		 * Get the map element for the map.
		 *
		 * @returns {object} The map.
		 */
		getMap: function() {
			return this.map;
		},

		/**
		 * Get the info window element for map markers.
		 *
		 * @returns {object} The info window.
		 */
		getInfoWindow: function() {
			return this.infoWindow;
		},

		populateMap: function() {
			var map = this.getMap(),
				infoWindow = this.getInfoWindow(),
				latitude = this.getSetting( 'latitude' ),
				longitude = this.getSetting( 'longitude' );

			if ( !map || !latitude || !latitude ) {
				return;
			}

			var mapMarker = new MapMarker( map, {
				'title': this.getSetting( 'name' ),
				'address': this.getSetting( 'address' ),
				'latitude': latitude,
				'longitude': longitude,
				'infoWindow': infoWindow,
				'showDirectionsLink': true
			} );
		}
	};

	$window.on( 'google_maps_loaded', function() {
		$( '.location-map-finder' ).each( function() {
			var finder = new LocationMapFinder( this );

			locationMapFinders.push( finder );
		} );

		$( '.location-map' ).each( function() {
			var map = new LocationMap( this );

			locationMaps.push( map );
		} );

		$( '.location-finder-component' ).each( function() {
			var finder = new LocationFinderComponent( this );

			locationFinderComponents.push( finder );
		} );
	} );

} )( window, jQuery );
